/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Create_Team_Failed_LogInputs */

const en_team_manager_create_team_failed_log = /** @type {(inputs: Team_Manager_Create_Team_Failed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create team`)
};

const fr_team_manager_create_team_failed_log = /** @type {(inputs: Team_Manager_Create_Team_Failed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la création de l’équipe`)
};

const de_team_manager_create_team_failed_log = /** @type {(inputs: Team_Manager_Create_Team_Failed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team konnte nicht erstellt werden`)
};

const it_team_manager_create_team_failed_log = /** @type {(inputs: Team_Manager_Create_Team_Failed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile creare il team`)
};

const ru_team_manager_create_team_failed_log = /** @type {(inputs: Team_Manager_Create_Team_Failed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось создать команду`)
};

const es_team_manager_create_team_failed_log = /** @type {(inputs: Team_Manager_Create_Team_Failed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo crear el equipo`)
};

const zh_cn2_team_manager_create_team_failed_log = /** @type {(inputs: Team_Manager_Create_Team_Failed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建团队失败`)
};

const ja_team_manager_create_team_failed_log = /** @type {(inputs: Team_Manager_Create_Team_Failed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームの作成に失敗しました`)
};

const hi_team_manager_create_team_failed_log = /** @type {(inputs: Team_Manager_Create_Team_Failed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम बनाने में विफल`)
};

const pt_pt2_team_manager_create_team_failed_log = /** @type {(inputs: Team_Manager_Create_Team_Failed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao criar equipe`)
};

/**
* | output |
* | --- |
* | "Failed to create team" |
*
* @param {Team_Manager_Create_Team_Failed_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_create_team_failed_log = /** @type {((inputs?: Team_Manager_Create_Team_Failed_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Create_Team_Failed_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_create_team_failed_log(inputs)
	if (locale === "de") return de_team_manager_create_team_failed_log(inputs)
	if (locale === "it") return it_team_manager_create_team_failed_log(inputs)
	if (locale === "ru") return ru_team_manager_create_team_failed_log(inputs)
	if (locale === "es") return es_team_manager_create_team_failed_log(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_create_team_failed_log(inputs)
	if (locale === "ja") return ja_team_manager_create_team_failed_log(inputs)
	if (locale === "hi") return hi_team_manager_create_team_failed_log(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_create_team_failed_log(inputs)
	return en_team_manager_create_team_failed_log(inputs)
});